import { Component, Inject, HostListener, Input, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Event } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettingService, AppUtilityService } from '../../app.service';
import { UserInfoService, IUserProfile } from '../user-info.service';
import { UserAPIService, SessionAPIService } from '../user-api.service';
import { ZoneAPIService } from '../../zone/zone-api.service';
import { TSignupLoginResult, SignupLoginService, SignupLoginDialog } from './signup-login.component';

@Component({
	selector: "app-global-account",
	template: "",
	standalone: false
})
export class GlobalAccountComponent {
	private myPopup: any = null;
	private completePopup: any = null;
	private postpone: number = 0;

	constructor(
		private dialog: MatDialog,
		private signupLoginSrv: SignupLoginService,
		private userAPI: UserAPIService,
		private userInfo: UserInfoService
	) { }


	private askGlobalAccount(): void {
		if (this.myPopup != null) {
			return;
		}
		this.myPopup = this.dialog.open(
			GlobalAccountIntroDialog,
			{
				disableClose: true,
				panelClass: 'jmDialogNoScroll',
				width: "90%",
				maxWidth: "800px",
				data: {
					postpone: this.postpone
				}
			}
		);
	}

	private showGlobalAccounComplete() {
		if (this.completePopup != null) {
			return;
		}
		// prompt global account intro if it is needed
		let completeType: "login" | "signup" = this.signupLoginSrv.promptGlobalAccountIntro;
		this.completePopup = this.dialog.open(
			GlobalAccountCompleteDialog,
			{
				disableClose: true,
				panelClass: 'jmDialogNoScroll',
				width: "600px",
				data: {
					completeType: completeType
				}
			}
		);
		this.completePopup.afterClosed().subscribe(
			() => {
				this.signupLoginSrv.promptGlobalAccountIntro = null;
			}
		);
	}

	private checkStatus() {
		let user: IUserProfile = this.userInfo.getProfile();
		if (user.NeedGlobalAccount && !this.signupLoginSrv.askedGlobalAccount) {
			// check how many times users have cancel
			this.userAPI.getGlobalAccountReqiretCount().subscribe({
				next: (response: any) => {
					try {
						let hasTries: number = parseInt(response.Detail);
						this.postpone = hasTries >= 3 ? 0 : (3 - hasTries);
					}
					catch {
						this.postpone = 3;
					}
				},
				error: (err: any) => {
					console.log(err);
					this.postpone = 3;
				},
			}).add(() => {
				this.askGlobalAccount();
			});
		}
		else if (user.OtherAccounts != null && user.OtherAccounts.length > 0 && user.IsPublicZone && this.signupLoginSrv.promptGlobalAccountIntro != null) {
			this.showGlobalAccounComplete();
		}
	}

	ngOnDestroy() {
		if (this.myPopup != null) {
			this.myPopup.close();
		}
		if (this.completePopup != null) {
			this.completePopup.close();
		}
	}

	ngAfterViewInit(): void {
		this.checkStatus();
	}
}


@Component({
	templateUrl: "./global-account-intro.dialog.html",
	standalone: false
})
export class GlobalAccountIntroDialog {
	allowCancel: boolean = false;
	postpone: number = 0;
	askExist: boolean = false;
	private myPopup: any = null;
	screenWidth: number = window.innerWidth;

	constructor(
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<GlobalAccountIntroDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private signupLoginSrv: SignupLoginService,
		private userAPI: UserAPIService,
	) {
		this.allowCancel = data.allowCancel;
		this.postpone = data.postpone;
		this.allowCancel = this.postpone <= 0 ? false : true;
	}

	private doSignupLogin(choice: TSignupLoginResult) {
		this.myPopup = this.dialog.open(
			SignupLoginDialog,
			{
				width: "100%",
				height: "100%",
				disableClose: true,
				autoFocus: true,
				panelClass: 'jmSignupLogin',
				data: {
					display: choice,
					allowCancel: this.allowCancel,
					globalAccount: true
				}
			}
		);
		this.myPopup.afterClosed().subscribe(
			(choice: TSignupLoginResult) => {
				// if cancel, donothing. Give users a chance to select Yes/No again
				if (choice !== "cancel") {
					this.close(choice);
				}
			}
		);
	}

	close(action: TSignupLoginResult) {
		// if cancel, do not ask global account again until user login again
		if (action === "cancel") {
			this.signupLoginSrv.askedGlobalAccount = true;
			this.userAPI.updateGlobalAccountReqiretCount().subscribe();
			this.dialogRef.close();
		}
		else {
			this.doSignupLogin(action);
		}
	}

	ngOnDestroy() {
		if (this.myPopup != null) {
			this.myPopup.close();
		}
	}

	ngAfterViewInit(): void {
	}
}


@Component({
	templateUrl: "./global-account-complete.dialog.html",
	standalone: false
})
export class GlobalAccountCompleteDialog {
	completeType: "login" | "signup";

	constructor(
		private dialogRef: MatDialogRef<GlobalAccountIntroDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.completeType = data.completeType;
	}

	close() {
		this.dialogRef.close();
	}
}


@Component({
	selector: "app-global-login",
	templateUrl: "./global-login.component.html",
	styleUrls: ["./login.scss"],
	standalone: false
})
export class GlobalLoginComponent {
	@Input() allowCancel: boolean = true;
	@Input() onClose: Function = null;

	constructor(
		private sessionAPI: SessionAPIService,
		private userAPI: UserAPIService,
		private zoneAPI: ZoneAPIService
	) { }

	frmLogin: {
		username: string,
		usernameStatus?: boolean,
		password: string,
		passwordStatus?: boolean,
		myZone: string,
		zonesUpdating: boolean
	} = {
			username: "",
			usernameStatus: null,
			password: "",
			passwordStatus: null,
			myZone: "",
			zonesUpdating: false
		};

	msg: string = "";
	isLogging: boolean = false;
	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	//#region username
	@ViewChild('txtU') txtUsername: ElementRef;

	private populateZones(username: string) {
		this.frmLogin.zonesUpdating = true;
		this.userAPI
			.checkUserNameExist(username, this.frmLogin.myZone)
			.subscribe(
				response => {
					this.frmLogin.zonesUpdating = false;
					if (response.Zones.length > 0) {
						this.frmLogin.usernameStatus = true;
						setTimeout(() => { this.txtPassword.nativeElement.focus(); }, 500);
					}
					else {
						this.frmLogin.usernameStatus = false;
					}
				},
				err => {
					console.log(err);
					this.frmLogin.usernameStatus = null;
				}
			);
	}
	//#endregion username

	//#region password
	@ViewChild('txtP') txtPassword: ElementRef;

	txtPwType: string = 'password';
	showPassword(enforce: string) {
		this.txtPassword.nativeElement.type = this.txtPassword.nativeElement.type === 'password' ? 'text' : 'password';
		if (enforce != null) {
			this.txtPassword.nativeElement.type = enforce;
			this.txtPwType = enforce;
		}
	}
	//#endregion password

	//#region perform login
	private doLogin() {
		this.isLogging = true;
		if (this.canLogin()) {
			this.sessionAPI.globalLogin(this.frmLogin.username, this.frmLogin.password).subscribe(
				success => {
					this.isLogging = false;
					this.onClose('login');
				},
				error => {
					console.log(error);
					let err = error.error;
					this.isLogging = false;
					this.frmLogin.passwordStatus = false;
					if (err != null && err.Code != null && err.Code === '70000') {
						this.msg = 'Unable to verify account, please contact <a href="mailto:help@journeysmap.com">help@journeysmap.com</a>.';
					}
					else {
						this.msg = 'Uh oh. Something isn\'t quite right. Please try again.';
					}
					this.txtUsername.nativeElement.blur();
					this.txtPassword.nativeElement.blur();
				}
			);
		}
		else {
			this.isLogging = false;
			this.msg = 'Uh oh. All fields are required.';
		}
	}

	canLogin() {
		if (!this.frmLogin.zonesUpdating && this.frmLogin.username.trim() !== "" && this.frmLogin.password.trim() !== "" && (this.frmLogin.usernameStatus ?? false) === true) {
			return true;
		}
		else {
			return false;
		}
	}

	submitLogin(e: any, nextStep: boolean) {
		if (e == null) {
			return;
		}
		if (e.type === 'keydown' && e.keyCode !== 13 && e.keyCode !== 9) {
			this.msg = '';
			return;
		}

		if (e.currentTarget.id === this.txtUsername.nativeElement.id && this.frmLogin.username.trim().length > 0) {
			if ((e.type === 'keydown' && (e.keyCode === 13 || e.keyCode === 9)) || e.type == 'blur'
			) {
				this.populateZones(this.frmLogin.username);
			}
		}

		if (this.canLogin() && (e.keyCode === 13 || nextStep != null)) {
			this.doLogin();
		}
	}
	//#endregion perform login

	//region UI switch
	createAccount(e: any) {
		e.preventDefault();
		this.onClose('showSignup');
	}

	cancel(e: any): void {
		e.preventDefault();
		this.onClose('cancel');
	}
	//endregion UI switch

	ngAfterViewInit(): void {
		setTimeout(() => {
			try { this.txtUsername.nativeElement.focus(); }
			catch (ex) { ; }
		}, 500);
	}

	ngOnInit(): void {
		this.zoneAPI.getPublicZone().subscribe(
			response => {
				this.frmLogin.myZone = response.Client;
			},
			err => {
				console.log(err);
			}
		);
	}
}


@Component({
	selector: "app-global-signup",
	templateUrl: "./global-signup.component.html",
	styleUrls: ["./login.scss"],
	standalone: false
})
export class GlobalSignupComponent {
	@Input() isPublic: boolean = true;
	@Input() allowCancel: boolean = false;
	@Input() onClose: Function = null;

	constructor(
		@Inject(DOCUMENT) private doc: any,
		private sessionAPI: SessionAPIService,
		private userAPI: UserAPIService,
		private zoneAPI: ZoneAPIService
	) { }

	minAge: number = 13;
	private usernameMinLen: number = 4;
	iStepHighestReached: number = 0;
	isWaiting: boolean = false;
	signupMsg: string = '';
	doneSignup: boolean = false;
	alreadySignup: boolean = false;
	currentStep: number = 2;
	usernameTaken: boolean = false;

	steps = [
		{ name: "username" },
		{ name: "password" },
		{ name: "final" }
	];

	frmSignup: {
		byEmail: boolean,
		email: string,
		emailStatus?: boolean,
		username: string,
		usernameStatus?: boolean,
		usernameMsg: string,
		pw1: string,
		pw1Status?: boolean,
		pw2: string,
		pw2Status?: boolean,
		pwMsg: string
	} = {
			byEmail: true,
			email: '',
			emailStatus: null,
			username: '',
			usernameStatus: null,
			usernameMsg: '',
			pw1: '',
			pw1Status: null,
			pw2: '',
			pw2Status: null,
			pwMsg: ''
		};

	@ViewChild('btnUsername') btnUsername: ElementRef<HTMLButtonElement>;
	@ViewChild('txtEmail') txtEmail: ElementRef<HTMLInputElement>;
	@ViewChild('txtUsername') txtUsername: ElementRef<HTMLInputElement>;
	@ViewChild('txtPw1') txtPw1: ElementRef<HTMLInputElement>;
	@ViewChild('txtPw2') txtPw2: ElementRef<HTMLInputElement>;
	@ViewChild('btnPwNext') btnPwNext: ElementRef<HTMLButtonElement>;

	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	private changeStep(toStep: number) {
		if (toStep > this.currentStep) {
			if (this.currentStep - 1 === this.iStepHighestReached) {
				this.iStepHighestReached++;
			}
		}
		this.currentStep = toStep
		switch (this.currentStep) {
			case 0:
				setTimeout(() => {
					if (this.frmSignup.byEmail) {
						this.txtEmail.nativeElement.focus();
					}
					else {
						this.txtUsername.nativeElement.focus();
					}
				}, 250);
				break;
			case 1:
				setTimeout(() => { this.txtPw1.nativeElement.focus(); }, 250);
				break;
			case 2:
				//final, do nothing
				break;
			default:
				this.currentStep = 0;
				setTimeout(() => {
					if (this.frmSignup.byEmail) {
						this.txtEmail.nativeElement.focus();
					}
					else {
						this.txtUsername.nativeElement.focus();
					}
				}, 250);
				break;
		}
	}

	prgIndicatorJumpTo(e: any, toStep: number) {
		switch (this.currentStep) {
			case 0:
				this.checkUsername(e, toStep);
				break;
			case 1:
				this.checkPassword(e, toStep);
				break;
		}
	}

	//#region username
	toggleUsernameEmail() {
		this.frmSignup.byEmail = !this.frmSignup.byEmail;
		if (this.frmSignup.byEmail) {
			this.frmSignup.username = '';
			this.frmSignup.usernameStatus = null;
		}
		else {
			this.frmSignup.email = '';
			this.frmSignup.emailStatus = null;
		}
	}

	checkUsername(e: any, nextStep?: number) {
		if (e.keyCode !== 9 && e.type === 'keydown') {
			return;
		}

		this.frmSignup.emailStatus = null;
		this.frmSignup.usernameStatus = null;
		this.frmSignup.email = this.frmSignup.email.trim();
		this.frmSignup.username = this.frmSignup.username.trim();
		let loginName = this.frmSignup.byEmail ? this.frmSignup.email : this.frmSignup.username;

		if (e.keyCode === 13 || nextStep != null || e.keyCode === 9) {
			if (this.frmSignup.byEmail) {
				this.frmSignup.usernameStatus = null;
				if (loginName.length < this.usernameMinLen || !AppUtilityService.isEmail(loginName)) {
					this.frmSignup.emailStatus = false;
				}
				else {
					this.frmSignup.emailStatus = true;
				}
			}
			else {
				this.frmSignup.emailStatus = null;
				if (loginName.length < this.usernameMinLen) {
					this.frmSignup.usernameStatus = false;
				}
				else {
					this.frmSignup.usernameStatus = true;
				}
			}

			if (this.frmSignup.emailStatus === false || this.frmSignup.usernameStatus === false) {
				this.frmSignup.usernameMsg = this.frmSignup.byEmail ? 'Oops! Something is funky. Please enter a valid email address.' : 'Oops! Please enter a valid username.';
			}
			else {
				//username is unique per zone. Zone is unknown until users decide having access code or not. 
				// so no point to check username here
				if (e.keyCode !== 9) {
					this.changeStep(nextStep == null ? this.currentStep + 1 : nextStep);
				}
			}
		}
		else {
			this.frmSignup.usernameMsg = "";
		}
	}
	//#endregion username

	//#region password
	txtPw1Type: string = 'password';
	txtPw2Type: string = 'password';	
	showPassword(id: string) {
		var input = this.doc.getElementById(id);
		if (input != null) {
			input.type = (input.type === 'password') ? 'text' : 'password';
			if (id === 'txtPw1') {
				this.txtPw1Type = input.type;
			}
			if (id === 'txtPw2') {
				this.txtPw2Type = input.type;
			}
		}
	}
	pw1isFocused: boolean = false;
	checkPassword(e: any, nextStep?: number) {
		if (e != null && e.currentTarget != null && e.currentTarget.value != null) {
			e.currentTarget.value = e.currentTarget.value.trim();
		}

		if (e.type === 'focus' && e.target.id === 'txtPw1') {
			this.pw1isFocused = true;
		}
		if (e.type === 'blur' && e.target.id === 'txtPw1') {
			this.pw1isFocused = false;
		}

		if (e.type === 'focus') {
			if (this.frmSignup.pw1Status === false) {
				this.frmSignup.pw1Status = null;
			}
			if (this.frmSignup.pw2Status === false) {
				this.frmSignup.pw2Status = null;
			}
			this.frmSignup.pwMsg = "";
			return;
		}

		if (e.type === 'keyup' && e.keyCode !== 9 && e.keyCode !== 13) {
			if (e.target.id === 'txtPw1') {
				this.frmSignup.pw1Status = null;
			}
			if (e.target.id === 'txtPw2') {
				this.frmSignup.pw2Status = null;
			}
			return;
		}

		if ((e.currentTarget.id === 'txtPw1' && (e.keyCode === 9 || e.keyCode === 13)) || nextStep != null) {
			if (this.frmSignup.pw2Status === false) {
				this.frmSignup.pw2Status === null;
			}
			var pw = AppUtilityService.validatePassword(this.txtPw1.nativeElement.value);
			this.frmSignup.pw1Status = pw.strength < 100 ? false : true;

			if (this.frmSignup.pw1Status === true) {
				this.frmSignup.pwMsg = "";
				if (nextStep == null) {
					setTimeout(() => { this.txtPw2.nativeElement.focus(); }, 100);
				}
			} else {
				this.frmSignup.pw1Status = false;
				this.txtPw1.nativeElement.blur();
				this.frmSignup.pwMsg = pw.message;
			}
		}

		if ((e.currentTarget.id === 'txtPw2' && (e.keyCode === 13 || e.keyCode === 9)) || nextStep != null) {
			//bc some sort of timing thing happens that sends us back in here on keyup after tabbing or entering out of pw1 field
			if (e.type === 'keyup') {
				return;
			}

			if (this.frmSignup.pw1Status === false) {
				this.frmSignup.pw1Status === null;
			}
			let pw = AppUtilityService.validatePassword(this.txtPw2.nativeElement.value);
			this.frmSignup.pw2Status = pw.strength < 100 ? false : true;

			if (this.frmSignup.pw2Status === true) {
				this.frmSignup.pwMsg = "";
				if (this.frmSignup.pw1 === this.frmSignup.pw2) {
					this.frmSignup.pw1Status === true;
					this.frmSignup.pw2Status === true;
					this.frmSignup.pwMsg = "";
					//only go to next screen if user hit enter or next button (tab should just provide validation feedback)
					if (e.keyCode === 13 || (nextStep != null && nextStep === this.currentStep + 1)) {
						this.submitSignup();
					}
					else if (nextStep != null) {
						this.changeStep(nextStep);
					}
					else {
						if (e.keyCode === 9) {
							setTimeout(() => { this.btnPwNext.nativeElement.focus(); }, 100);
						}
					}
				} else {
					this.frmSignup.pw1Status = false;
					this.frmSignup.pw2Status = false;
					this.txtPw2.nativeElement.blur();
					this.frmSignup.pwMsg = 'Oops! Please make sure both passwords are the same.';
					if (e.keyCode === 9) {
						setTimeout(() => { this.btnPwNext.nativeElement.focus(); }, 100);
					}
				}
			}
			else {
				this.frmSignup.pw2Status = false;
				this.txtPw2.nativeElement.blur();
				this.frmSignup.pwMsg = pw.message;
			}
		}
	}
	//#endregion password


	private signupErrorCode = '';
	reviewRetry() {
		if (this.signupErrorCode === '50004') {
			this.changeStep(0);
		}
		else {
			this.changeStep(1);
		}
	}

	private submitSignup() {
		this.currentStep = this.steps.length - 1;
		this.signupErrorCode = '';
		this.doneSignup = false;
		this.isWaiting = true;
		this.usernameTaken = false;

		let username = this.frmSignup.byEmail ? this.frmSignup.email.trim() : this.frmSignup.username.trim();
		// if username is like email, copy it to email field
		let email = AppUtilityService.isEmail(username) ? username : '';

		let reg = {
			Email: email,
			Password: this.frmSignup.pw1,
			UserName: username
		};

		this.signupMsg = 'Submit sign up info ...';
		this.userAPI.globalRegister(reg).subscribe(
			success => {
				if (success !== null && success.UserName !== null && success.Password !== null) {
					this.signupMsg = 'Login...';
					// try to login with new user/pw
					this.zoneAPI.getPublicZone().subscribe(
						response => {
							let publicZone: string = response.Client;
							this.sessionAPI.signOn(success.UserName, success.Password, publicZone).subscribe(
								success => {
									this.doneSignup = true;
									this.closeSignup();
								},
								error => {
									console.log(error);
									this.signupMsg = 'Fail to login automatically. Please try to login manually.';
									this.isWaiting = false;
								}
							);
						},
						err => {
							console.log(err);
							this.signupMsg = 'Fail to login automatically. Please try to login manually.';
							this.isWaiting = false;
						}
					);
				}
				else {
					this.signupMsg = 'Fail to login automatically. Please try to login manually.';
					this.isWaiting = false;
				}
			},
			error => {
				console.log(error);
				error = error.error;
				this.signupErrorCode = (error.Code ?? "");
				if (error.Code === '50004') {
					this.usernameTaken = true;
				}
				else {
					this.signupMsg = error.Detail;
				}
				this.isWaiting = false;
			}
		);
	}

	private closeSignup() {
		this.onClose('signup');
	}

	goLogin() {
		this.onClose('showLogin');
	}

	cancel(e: any) {
		this.onClose('cancel');
	}

	login(e: any): void {
		e.preventDefault();
		this.onClose('showLogin');
	}

	ngOnInit(): void {
		this.isWaiting = false;
		this.signupMsg = '';
		this.doneSignup = false;
		this.alreadySignup = false;
		this.currentStep = 0;
	}
}
